import {
    UPDATE_TABLE_PROPS
} from '../actions/actionTypes';

export const updateTableProps = (tableName, tableProps) => (dispatch, getState) => {
    const updatedState = getState().tableProps;
    updatedState[tableName] = tableProps;

    dispatch({
        type:    UPDATE_TABLE_PROPS,
        payload: updatedState
    });
};
